import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import SectionContainer from './SectionContainer';
import SectionEyebrow from './SectionEyebrow';
import { whyChooseUsPoints } from './content';

const WhyChooseUs = () => (
  <SectionContainer id="why-choose-us" sx={{ py: { xs: 6, md: 10 } }}>
    <Box sx={{ display: 'flex', flexDirection: { xs: 'column-reverse', md: 'row' }, alignItems: 'center', gap: { xs: 5, md: 8 } }}>
      <Box
        sx={(theme) => ({
          flex: 1,
          width: '100%',
          aspectRatio: '4 / 3',
          borderRadius: 5,
          position: 'relative',
          overflow: 'hidden',
          background:
            theme.palette.mode === 'dark'
              ? 'radial-gradient(80% 80% at 30% 30%, rgba(37,99,235,0.35), rgba(8,11,20,0) 70%), linear-gradient(135deg, #1c2333, #0b0e17)'
              : 'linear-gradient(135deg, #DCE9FF 0%, #F3E8FF 100%)',
        })}
      >
        <Box sx={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Box
            sx={{
              width: { xs: 120, md: 160 },
              height: { xs: 120, md: 160 },
              borderRadius: '50%',
              bgcolor: '#fff',
              boxShadow: '0 12px 32px rgba(15,23,42,0.14)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img
              src="/logo-icon.svg"
              alt="Remembr"
              style={{ width: '58%', height: '58%', display: 'block' }}
            />
          </Box>
        </Box>
      </Box>

      <Box sx={{ flex: 1, width: '100%' }}>
        <SectionEyebrow color="#8B5CF6">Why Remembr Stands Out</SectionEyebrow>
        <Typography variant="h2" sx={{ fontWeight: 700, mb: 3, fontSize: { xs: 24, md: 32 } }}>
          Built to be the only diary you'll ever need
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {whyChooseUsPoints.map(({ label, color }) => (
            <Box key={label} sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <Box
                sx={{
                  width: 26,
                  height: 26,
                  borderRadius: '50%',
                  bgcolor: color,
                  color: '#fff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}
              >
                <CheckIcon sx={{ fontSize: 16 }} />
              </Box>
              <Typography sx={{ fontWeight: 600, fontSize: 15.5 }}>{label}</Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  </SectionContainer>
);

export default WhyChooseUs;
